<!-- TODO: implement AODA requirements -->
<div [ngClass]="{'px-6': !isTransitionPlan}">
    <div [ngClass]="{'pt-4': !isTransitionPlan}">
        <div #eyebrowText class="gb-body2" *ngIf="plan.eyebrowText">
            {{plan.eyebrowText}}
        </div>
        <div class="d-flex align-items-center">
            <div class="d-flex flex-column">
              <div class="gb-headline2">
                {{plan.planName}}
              </div>
              @if(plan.billingCadence && type === 'SUBSCRIPTIONS'){
                @if(plan.templateType === 'PREPAID' && isPrepaidExpiringSoon(plan)){
                  <div class="gb-body2 error-red-text">   
                    <svg class="icon-bank -2" width="35px" height="20px" fill="#B50000">
                        <use id="svg-payment-type" alt="warning sign" [attr.href]="'/content/dam/gmownercenter/global/resources/icons/symbol-defs.svg#icon-caution' | link"></use>
                    </svg>
                    <span style="white-space: pre-line;">{{plan.billingCadence}}</span>
                  </div>
                }@else{
                  <div style="white-space: pre-line;">{{ plan.billingCadence }}</div>
                }
              }
            </div>
            <div [ngClass]="isTransitionPlan ? 'position-absolute' : 'ml-auto'" 
                 [ngStyle]="isTransitionPlan ? {'right': '0', 'top': '32px', 'transform': 'translateY(-50%)'} : {}" 
                 *ngIf="plan?.daysLeft">
                <webu-days-remaining-component [numberOfDaysLeft]="plan.daysLeft" [productType]="plan.templateType"></webu-days-remaining-component>
            </div>
            <div class="ml-auto" *ngIf="productTag">
                <!-- Product tag if more than 90 days  -->
                <webu-product-tag [productTag]="productTag"></webu-product-tag>
            </div>
        </div>

        <div class="gb-body3 pt-1 gb-color-grey-mid-dark" *ngIf="type !== 'SUBSCRIPTIONS'">
            <div style="white-space: pre-line;">{{ plan.billingCadence }}</div>
        </div>
        <div *ngIf="doDisplayHeaderLine">
            <hr class="mb-0 mt-2">
        </div>
    </div>

    <div *ngIf="type !== 'DIGITAL_UPGRADES'">
        <webu-plan-feature-list [plan]="plan"></webu-plan-feature-list>
    </div>

    <ng-container *ngIf="plan && plan.isData && !isBundledPlan()">
        <webu-data-bar [plan]="plan"></webu-data-bar>
    </ng-container>

    <ng-template #loadingComponent>
        <ox-loading></ox-loading>
    </ng-template>

</div>
